module.exports = __webpack_public_path__ + "static/media/Trainicon03@2x.5b1eb3db.png";